import {
  useMemo,
  useState,
} from "react";

import {
  useSelector,
} from "react-redux";

import {
  sendSupportRequest,
} from "../../services";

import "../../assets/css/support.css";

const problemTypes = [
  "Acceso a la plataforma",
  "Curso o contenido",
  "Evaluación",
  "DC-3 / Constancia",
  "Mi perfil",
  "Problema técnico",
  "Otro",
];

export const Support = () => {
  const {
    user,
    userCourses,
  } = useSelector(
    (state) => state
  );

  const [
    form,
    setForm,
  ] = useState({
    contact_phone:
      user?.telephone || "",
    problem_type: "",
    course: "",
    description: "",
  });

  const [
    sending,
    setSending,
  ] = useState(false);

  const [
    success,
    setSuccess,
  ] = useState(null);

  const [
    error,
    setError,
  ] = useState("");

  const support = {
    name:
      "Soporte Proceso Seguro",
    area:
      "Soporte de plataforma",
    whatsapp:
      "524428247191",
    whatsappDisplay:
      "442 824 7191",
    email:
      "soporteqro@procesoseguro.com",
    schedule:
      "Lunes a viernes de 8:00 a 17:30 hrs",
  };

  const displayName = [
    user?.name,
    user?.lastname,
  ]
    .filter(Boolean)
    .join(" ")
    .trim();

  const courses =
    useMemo(() => {
      const source =
        Array.isArray(
          userCourses
        )
          ? userCourses
          : [];

      const unique =
        new Map();

      source.forEach(
        (item) => {
          const title =
            item?.course_title ||
            item?.title ||
            item?.course?.title ||
            "";

          if (title) {
            unique.set(
              title,
              title
            );
          }
        }
      );

      return Array.from(
        unique.values()
      ).sort(
        (a, b) =>
          a.localeCompare(
            b,
            "es"
          )
      );
    }, [userCourses]);

  const handleChange = (
    { target }
  ) => {
    const {
      name,
      value,
    } = target;

    setForm((old) => ({
      ...old,
      [name]: value,
    }));

    if (error) {
      setError("");
    }
  };

  const resetForm = () => {
    setForm({
      contact_phone:
        user?.telephone || "",
      problem_type: "",
      course: "",
      description: "",
    });

    setError("");
  };

  const handleSubmit =
    async (event) => {
      event.preventDefault();

      const contactPhone =
        form.contact_phone.trim();

      const problemType =
        form.problem_type.trim();

      const description =
        form.description.trim();

      if (!contactPhone) {
        setError(
          "Indica un teléfono o WhatsApp para poder contactarte."
        );
        return;
      }

      if (!problemType) {
        setError(
          "Selecciona el tipo de problema."
        );
        return;
      }

      if (!description) {
        setError(
          "Describe brevemente el problema."
        );
        return;
      }

      setSending(true);
      setError("");

      try {
        const response =
          await sendSupportRequest({
            contact_phone:
              contactPhone,
            problem_type:
              problemType,
            course:
              form.course.trim(),
            description,
          });

        if (
          !response?.reference
        ) {
          throw new Error(
            "No fue posible obtener la referencia."
          );
        }

        setSuccess({
          reference:
            response.reference,
        });

        resetForm();
      } catch (
        requestError
      ) {
        const message =
          requestError
            ?.response
            ?.data
            ?.message ||
          requestError
            ?.data
            ?.message ||
          requestError
            ?.message ||
          "No fue posible enviar la solicitud. Intenta nuevamente.";

        setError(message);
      } finally {
        setSending(false);
      }
    };

  return (
    <section className="support-v4-page">
      <div
        className="main-header anim"
        style={{
          "--delay": "0s",
        }}
      >
        Centro de ayuda
      </div>

      <div
        className="support-v4-shell anim"
        style={{
          "--delay": ".15s",
        }}
      >
        <div className="support-v4-heading">
          <div className="support-v4-heading-icon">
            <i className="fas fa-headset" />
          </div>

          <div>
            <span>
              SOPORTE PROCESO SEGURO
            </span>

            <h1>
              ¿En qué podemos ayudarte?
            </h1>

            <p>
              Envía tu solicitud
              directamente desde la
              plataforma. No necesitas
              abrir tu correo.
            </p>
          </div>
        </div>

        <div className="support-v4-grid">
          <div className="support-v4-form-card">
            {success ? (
              <div className="support-v4-success">
                <div className="support-v4-success-icon">
                  <i className="fas fa-check" />
                </div>

                <span>
                  SOLICITUD ENVIADA
                </span>

                <h2>
                  Recibimos tu solicitud
                </h2>

                <p>
                  Soporte Proceso Seguro
                  recibió tu mensaje y
                  también enviamos una
                  confirmación a tu correo.
                </p>

                <div className="support-v4-reference">
                  <small>
                    Referencia
                  </small>

                  <strong>
                    {
                      success.reference
                    }
                  </strong>
                </div>

                <button
                  type="button"
                  className="support-v4-new"
                  onClick={() => {
                    setSuccess(null);
                    resetForm();
                  }}
                >
                  <i className="fas fa-plus" />
                  Enviar otra solicitud
                </button>
              </div>
            ) : (
              <form
                onSubmit={
                  handleSubmit
                }
              >
                <div className="support-v4-form-title">
                  <div>
                    <span>
                      NUEVA SOLICITUD
                    </span>

                    <h2>
                      Reportar un problema
                    </h2>
                  </div>

                  <i className="fas fa-paper-plane" />
                </div>

                <div className="support-v4-user-grid">
                  <div className="support-v4-readonly">
                    <label>
                      Nombre
                    </label>

                    <div>
                      <i className="fas fa-user" />

                      <span>
                        {
                          displayName ||
                          "Usuario"
                        }
                      </span>
                    </div>
                  </div>

                  <div className="support-v4-readonly">
                    <label>
                      Correo
                    </label>

                    <div>
                      <i className="fas fa-envelope" />

                      <span>
                        {
                          user?.email ||
                          "Sin correo"
                        }
                      </span>
                    </div>
                  </div>
                </div>

                <div className="support-v4-field">
                  <label
                    htmlFor="contact_phone"
                  >
                    Teléfono / WhatsApp
                    <strong>*</strong>
                  </label>

                  <div className="support-v4-control">
                    <i className="fab fa-whatsapp" />

                    <input
                      id="contact_phone"
                      name="contact_phone"
                      type="tel"
                      maxLength={30}
                      placeholder="Ej. 442 123 4567"
                      value={
                        form.contact_phone
                      }
                      onChange={
                        handleChange
                      }
                      disabled={
                        sending
                      }
                      required
                    />
                  </div>
                </div>

                <div className="support-v4-fields-row">
                  <div className="support-v4-field">
                    <label
                      htmlFor="problem_type"
                    >
                      Tipo de problema
                      <strong>*</strong>
                    </label>

                    <div className="support-v4-control">
                      <i className="fas fa-list" />

                      <select
                        id="problem_type"
                        name="problem_type"
                        value={
                          form.problem_type
                        }
                        onChange={
                          handleChange
                        }
                        disabled={
                          sending
                        }
                        required
                      >
                        <option value="">
                          Selecciona una opción
                        </option>

                        {problemTypes.map(
                          (type) => (
                            <option
                              key={
                                type
                              }
                              value={
                                type
                              }
                            >
                              {
                                type
                              }
                            </option>
                          )
                        )}
                      </select>
                    </div>
                  </div>

                  <div className="support-v4-field">
                    <label
                      htmlFor="course"
                    >
                      Curso relacionado
                    </label>

                    <div className="support-v4-control">
                      <i className="fas fa-book-open" />

                      {courses.length >
                      0 ? (
                        <select
                          id="course"
                          name="course"
                          value={
                            form.course
                          }
                          onChange={
                            handleChange
                          }
                          disabled={
                            sending
                          }
                        >
                          <option value="">
                            No aplica / seleccionar
                          </option>

                          {courses.map(
                            (course) => (
                              <option
                                key={
                                  course
                                }
                                value={
                                  course
                                }
                              >
                                {
                                  course
                                }
                              </option>
                            )
                          )}
                        </select>
                      ) : (
                        <input
                          id="course"
                          name="course"
                          type="text"
                          maxLength={
                            180
                          }
                          placeholder="Opcional"
                          value={
                            form.course
                          }
                          onChange={
                            handleChange
                          }
                          disabled={
                            sending
                          }
                        />
                      )}
                    </div>
                  </div>
                </div>

                <div className="support-v4-field">
                  <label
                    htmlFor="description"
                  >
                    Describe el problema
                    <strong>*</strong>
                  </label>

                  <textarea
                    id="description"
                    name="description"
                    maxLength={5000}
                    rows={6}
                    placeholder="Indica qué estabas intentando hacer y qué ocurrió..."
                    value={
                      form.description
                    }
                    onChange={
                      handleChange
                    }
                    disabled={
                      sending
                    }
                    required
                  />

                  <div className="support-v4-count">
                    {
                      form.description
                        .length
                    }{" "}
                    / 5000
                  </div>
                </div>

                {error && (
                  <div className="support-v4-error">
                    <i className="fas fa-exclamation-circle" />

                    <span>
                      {error}
                    </span>
                  </div>
                )}

                <button
                  type="submit"
                  className="support-v4-submit"
                  disabled={
                    sending
                  }
                >
                  {sending ? (
                    <>
                      <span className="support-v4-spinner" />
                      Enviando...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-paper-plane" />
                      Enviar solicitud
                    </>
                  )}
                </button>
              </form>
            )}
          </div>

          <aside className="support-v4-sidebar">
            <div className="support-v4-side-card">
              <div className="support-v4-side-heading">
                <div className="support-v4-avatar">
                  PS
                </div>

                <div>
                  <strong>
                    {support.name}
                  </strong>

                  <span>
                    {support.area}
                  </span>
                </div>
              </div>

              <div className="support-v4-contact-list">
                <div>
                  <i className="fab fa-whatsapp" />

                  <span>
                    <small>
                      WhatsApp
                    </small>

                    <strong>
                      {
                        support.whatsappDisplay
                      }
                    </strong>
                  </span>
                </div>

                <div>
                  <i className="fas fa-envelope" />

                  <span>
                    <small>
                      Correo
                    </small>

                    <strong>
                      {
                        support.email
                      }
                    </strong>
                  </span>
                </div>

                <div>
                  <i className="far fa-clock" />

                  <span>
                    <small>
                      Horario
                    </small>

                    <strong>
                      {
                        support.schedule
                      }
                    </strong>
                  </span>
                </div>
              </div>
            </div>

            <div className="support-v4-tip">
              <i className="fas fa-info-circle" />

              <div>
                <strong>
                  Para atenderte más rápido
                </strong>

                <p>
                  Describe qué estabas
                  haciendo, qué mensaje
                  apareció y en qué curso
                  ocurrió.
                </p>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
};
